import { render, staticRenderFns } from "./DialogoComissaoParceiro.vue?vue&type=template&id=faaebd4a&scoped=true&"
import script from "./DialogoComissaoParceiro.vue?vue&type=script&lang=js&"
export * from "./DialogoComissaoParceiro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaebd4a",
  null
  
)

export default component.exports